module.exports = __webpack_public_path__ + "img/writeoff_dp.cfc003d8.svg";